import type { Tags } from '../types/tags.types';
import type { RootState } from '@/app/store';

// Basic selectors
export const selectTagsState = (state: RootState) => state.tags;

export const selectTags = (state: RootState): Tags[] => state.tags.tags;

export const selectTagsLoading = (state: RootState): boolean =>
  state.tags.loading;

export const selectTagsError = (state: RootState): string | null =>
  state.tags.error;

export const selectTagsFilters = (state: RootState) =>
  state.tags.filtersOptions;

export const selectSearchFilters = (state: RootState) =>
  state.tags.filtersSearch;

export const selectSearchTags = (state: RootState) => state.tags.searchTags;

export const selectSearchTagsLoading = (state: RootState): boolean =>
  state.tags.searchTagsLoading;

export const selectUploadBulkImportErrorCsv = (
  state: RootState
): string | null => state.tags.uploadBulkImportErrorCsv;
